import { DROP_UPLOAD_CODES_ON_SUCCESS } from 'root/src/client/logic/tableItem/actionIds'

export default payload => ({
	type: DROP_UPLOAD_CODES_ON_SUCCESS,
	payload,
})
